/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportExcelConnectionTags$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected excel connection configuration
 */
  excelUid: string;
}

export function exportExcelConnectionTags(http: HttpClient, rootUrl: string, params: ExportExcelConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportExcelConnectionTags.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('excelUid', params.excelUid, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.ms-excel', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportExcelConnectionTags.PATH = '/stations/{uid}/excel/configuration/{excelUid}/export';
